let Api = {
	"TRADE_W_PRODUCT_PLATFINDPAGELIST": "/trade/w/product/platFindPageList", //分页查询商品列表
	"TRADE_N_PRODUCT_PLATFINDPAGELIST": "/trade/n/ShopHome/platFindPageList", //分页查询商品列表
	"TRADE_W_PRODUCT_FINDINFO": "/trade/w/product/findInfo", //查询商品详情
	"TRADE_W_COMMSALECATG_LIST": "/trade/w/CommSaleCatg/list", //获取商品销售分类列表
	"TRADE_W_PRODUCT_EXPORTPRODUCT": "/trade/w/product/exportProduct", //分页查询商品列表导出
	"TRADE_W_SHOPINFO_SHOPLIST": "/trade/w/shopInfo/shopList", //店铺list
	"TRADE_W_MALLPOPULARIZE_SAVEORUPDATE": "/trade/w/MallPopularize/saveOrUpdate", //商城推广新增编辑
	"TRADE_W_MALLPOPULARIZE_FINDDEFAULTINFO": "/trade/w/MallPopularize/findDefaultInfo", //商城推广查询默认
	// 资源
	"FARMCY_BASEINIT":"/difam/w/farmCyfzqk/baseResourceInit", // 基础资源初期化
	"FARMCY_BASESAVE":"/difam/w/farmCyfzqk/save", // 保存基础资源
	"FMCFK_VARIETYLIST":"/difam/w/farmCyfzqk/findVarietyList", // 品种列表
	"FMCFK_VARIETYSAVE":"/difam/w/farmCyfzqk/saveVariety", // 保存品种
	"FMCFK_VARIETYDEL":"/difam/w/farmCyfzqk/delVarietyById", // 品种删除
	"FMCFK_FINDVARSPRPAGE":"/difam/w/farmCyfzqk/findVarSprPage", // 品种分布列表
	"FMCFK_GETVARSPRDETAIL":"/difam/w/farmCyfzqk/getVarSprDetail",// 品种分布详情
	"FMCFK_VARSPRSAVE":"/difam/w/farmCyfzqk/varSprSave",// 品种分布保存
	"FMCFK_DELVARSPRBYID":"/difam/w/farmCyfzqk/delVarSprById",// 品种分布删除
	"FMPRICE_FINDPAGE":"/difam/w/farmPriceIndex/findPage", // 价格指数列表
	"FMPRICE_DELBYID":"/difam/w/farmPriceIndex/delById", // 价格指数删除
	"FMPRICE_TOSAVE":"/difam/w/farmPriceIndex/save", // 价格指数保存
	"FMPRICE_GETDETAIL":"/difam/w/farmPriceIndex/getDetail", // 价格指数查询
}
module.exports = Api